import functionName from './function-name.js';
import fails$1 from './fails.js';
import whitespaces$1 from './whitespaces.js';

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails = fails$1;
var whitespaces = whitespaces$1;
var non = '\u200B\u0085\u180E'; // check that a method works with the correct list
// of whitespaces and has a correct name

var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};

export { stringTrimForced as default };
